

























































































































































































































































































































































import { Vue, Component, Ref, Watch, Prop } from 'vue-property-decorator'
import { formatarCnpjOuCpf, formatarMoeda } from '@/shareds/formatadores'
import CamposDeItemDaVenda from './CamposDeItemDaVenda.vue'
import DialogoDeOfertasRelacionadas from './DialogoDeOfertasRelacionadas.vue'
import DialogoDeSelecionarVariante from '@/components/produto/DialogoDeSelecionarVariante.vue'
import type { FormProdutoSimplesFilho, OfertaRelacionadaDoProduto, Produto, ProdutoComVariantes, TabelaDePreco, Venda } from '@/models'
import { ItemDaVenda, Cliente, Comanda } from '@/models'
import {
	obterTotalDaVenda,
	obterTotalDoItem,
	contarItensDaVenda,
	obterSubTotalDoItem,
	obterTotalDosItensDaVenda,
	unificarItensDaVendaPorProduto,
	contarItensParaDevolucao,
	contarItensParaCompra,
} from '@/shareds/venda-shareds'
import UserLoginStore from '../../../store/vuex/authentication/UserLoginStore'
import BotaoDeDesconto from '@/views/application/venda/BotaoDeDesconto.vue'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import Confirmacao from '@/components/ui/Confirmacao.vue'
import CardDeInformacoesDoProduto from '@/components/produto/CardDeInformacoesDoProduto.vue'
import { VendaModule } from '@/store/vuex/venda/VendaStore'
import {
	displayNomeCompletoDoProduto,
	displayVariantes,
} from '@/shareds/produto-shareds'
import { isValidCPF } from '@brazilian-utils/brazilian-utils'
import { ComandaUseCase, FindClienteUseCase, FindEstoqueUseCase, FindModalidadeDeVendaUseCase, FindProdutoUseCase } from '@/usecases'
import { converterProdutoParaProdutoSimples } from '@/shareds/produto-shareds'
import type { VendaServiceAdapter } from '@/usecases'
import CampoDeClienteNoCaixa from './CampoDeClienteNoCaixa.vue'
import { nextTick, validarCpfOuCnpj, validarCnpjAlfanumerico } from '@/shareds/utils'
import { obrigatorio } from '@/shareds/regras-de-form'
import DialogoDeInformarVendedor from './DialogoDeInformarVendedor.vue'
import { Inject } from 'inversify-props'
import AplicarTabelaDePrecoUseCase from '@/usecases/tabela-de-precos/AplicarTabelaDePrecoUseCase'
import { v4 as uuidv4 } from 'uuid'
import { obterDescontoDaVenda } from '@/shareds/venda-shareds'
import { TipoDePagamento } from '@/models/venda/TipoDePagamento'
import AppStore from '@/store/vuex/aplicacao/AppStore'
import { getRequestError } from '@/helpers/axios-helpers'

@Component({
	components: {
		CamposDeItemDaVenda,
		BotaoDeDesconto,
		Confirmacao,
		CampoDeClienteNoCaixa,
		DialogoDeInformarVendedor,
		CardDeInformacoesDoProduto,
		DialogoDeOfertasRelacionadas,
		DialogoDeSelecionarVariante,
	},
})
export default class CardDeCompras extends Vue {
	@Prop({ type: Boolean }) pedindoCliente!: boolean
	@Prop({ type: Boolean }) loadingPagar!: boolean
	@Prop({ type: Boolean }) disabledPagar!: boolean
	@Prop({ type: Boolean, default: false}) permissaoConcedida!: boolean
	@Prop({ type: Boolean }) vendaComErro!: boolean
	@Prop({ type: Object }) tabelaDePrecoSelecionada!: TabelaDePreco | null
	@Ref() formVenda!: HTMLFormElement
	@Ref() panelHeaders!: { $el: HTMLElement }[]
	@Ref() camposDeVenda!: CamposDeItemDaVenda[]
	@Ref() botaoDePagamento!: { $el: HTMLButtonElement }
	@Ref() botaoDeFechamentoDeCaixa!: { $el: HTMLButtonElement }
	@Ref() botaoDeCancelamentoDeVenda!: { $el: HTMLButtonElement }
	@Ref() campoDeCliente!: CampoDeClienteNoCaixa
	@Ref() formsDeCamposDaVenda!: HTMLFormElement[]
	@Ref() painelExpansao!: HTMLDivElement
	@Ref() formDoDialogoDeCliente!: HTMLFormElement
	@Ref() campoDeClienteDoDialogo!: CampoDeClienteNoCaixa
	@Ref() dialogoDeVendedor!: DialogoDeInformarVendedor
	@Prop({ type: Boolean, default: false }) isTelaDeTroca!: boolean
	@Ref() confirmaZerarSaldo!: Confirmacao
	@Ref() dialogoDeOfertas!: DialogoDeOfertasRelacionadas
	@Ref() dialogoDeSelecaoDeVarianteDeOferta!: DialogoDeSelecionarVariante

	displayVariantes = displayVariantes
	formatarMoeda = formatarMoeda
	displayNomeCompletoDoProduto = displayNomeCompletoDoProduto
	obterSubTotalDoItem = obterSubTotalDoItem
	obterTotalDoItem = obterTotalDoItem
	contarItensDaVenda = contarItensDaVenda
	contarItensParaDevolucao = contarItensParaDevolucao
	contarItensParaCompra = contarItensParaCompra

	painel: number | null = null
	zIndexPagamentoEmAndamento = 13 // para o botão ficar em cima do overlay quando o pagamento ja foi inicializado
	menuAtivo: number[] = []
	buscandoCliente = false
	obrigatorio = obrigatorio
	item!: ItemDaVenda
	menuFixado: { [key: number]: boolean } = {}
	menuTimers: { [key: number]: number } = {}
	ofertasRelacionadasPorItem: { [produtoId: string]: OfertaRelacionadaDoProduto[] } = {}
	carregandoOfertasPorItem: { [produtoId: string]: boolean } = {}

	@Inject('VendaServiceAdapter')
	private vendaService!: VendaServiceAdapter

	findEstoqueUseCase = new FindEstoqueUseCase()
	comandaUseCase = new ComandaUseCase()
	findProdutoUseCase = new FindProdutoUseCase()

	cpfOuCnpjDoCliente: null | string =
		VendaModule.vendaAtual && VendaModule.vendaAtual.cpfDoCliente
			? formatarCnpjOuCpf(VendaModule.vendaAtual.cpfDoCliente)
			: null
	cpfOuCnpjDoClienteDoDialogo = this.cpfOuCnpjDoCliente
	valorDescontoASerAplicadoNaTroca = 0

	tiposDePagamentoBloqueadosDoCliente: TipoDePagamento[] = []
	findClienteUseCase = new FindClienteUseCase()
	findModalidadeDeVendaUseCase = new FindModalidadeDeVendaUseCase()

	get obrigatorioInformarCliente() {
		return (
			this.venda?.tipoDeTransacao === 'Devolução' ||
			this.venda.tipoDeTransacao === 'Outros' ||
			this.turnoDeVenda?.pontoDeVenda.criaPedidoNaVenda ||
			this.turnoDeVenda?.pontoDeVenda.exigeCliente ||
			this.possuiItemSelecionadoViaVitrineVirtual
		)
	}

	@Watch('venda.cpfDoCliente', { immediate: true })
	onChangeCpf() {
		console.log(`[DEBUG cpfCliente] 7-CardDeCompras.onChangeCpf disparou vendaCpf=${VendaModule.vendaAtual?.cpfDoCliente} campoAntes=${this.cpfOuCnpjDoCliente}`)
		this.cpfOuCnpjDoCliente =
		VendaModule.vendaAtual && VendaModule.vendaAtual.cpfDoCliente
			? formatarCnpjOuCpf(VendaModule.vendaAtual.cpfDoCliente)
			: null
		this.validaSeHaTiposDePagamentoDisponiveisParaCpf()
	}

	get vendaEDemonstracaoOuConsignado() {
		return this.venda.isVendaReaberta &&
			(this.venda.isConsignado || this.venda.isDemonstracao)
	}

	get exigeClienteCadastrado() {		
		return VendaModule.turnoDeVenda?.pontoDeVenda.exigeClienteCadastrado
	}	

	limparCpfDoCliente() {
		this.cpfOuCnpjDoCliente = null
		this.cpfOuCnpjDoClienteDoDialogo = null
	}

	atualizarCliente(cliente: Cliente) {
		if(this.retornoDeDemonstracao){
			AlertModule.setError('Atenção: não é possivel alterar o cliente para Retornos de Demonstração!')
			return
		}
		this.cpfOuCnpjDoClienteDoDialogo = formatarCnpjOuCpf(cliente.cnpjOuCpf)
	}

	async validarSeVendaExigeCpf() {
		if(!this.loja) return 
		if(!this.venda) return
		if(this.venda.isConsignado && !this.venda.cliente) {throw new Error('Venda consignada exige cpf/cnpj do cliente')}
		if(this.venda.isDemonstracao && !this.venda.cliente) {throw new Error('Venda de demonstração exige cpf/cnpj do cliente')}
		if(this.venda.isBrinde && !this.venda.cliente) {throw new Error('Venda brinde exige cpf/cnpj do cliente')}
		if(this.total > 10000 && !this.venda.cliente) {throw new Error('Venda com o valor acima de 10 mil é necessário informar um cliente')}
		if(this.exigeClienteCadastrado && !this.venda.cliente?.cnpjOuCpf) {throw new Error('Obrigatório informar um cliente cadastrado!')}
		const vendaPossuiItem = this.venda.itens.filter(item => item.quantidade > 0)

		if(vendaPossuiItem.length === 0 && this.venda.tipoDeTransacao === 'Venda' &&
		this.venda.isConsignado && !this.vendaEDemonstracaoOuConsignado) {throw new Error('Venda consignada exige pelo menos um item')}
		if(vendaPossuiItem.length === 0 && this.venda.tipoDeTransacao === 'Venda' &&
		this.venda.isDemonstracao && !this.vendaEDemonstracaoOuConsignado) {throw new Error('Venda de demonstração exige pelo menos um item')}
		if(this.exigeInformarVendedor) {
			if(this.venda.itens.some(item => (item.vendedor === null || item.vendedor === undefined))) {
				throw new Error('Existe um ou mais itens sem vendedor, verifique!')
			}
		}

		const tipoDeCliente = this.venda && this.venda.tipoDeCliente
			? this.venda.tipoDeCliente
			: null

		if(this.venda.cpfDoCliente && !validarCpfOuCnpj(this.venda.cpfDoCliente)) {
			throw new Error('CPF ou CPNJ informado é inválido')
		}

		if((this.venda?.itens.some(item => item.produto.isValePresente) ?? false) && this.venda.cliente === null )
			return AlertModule.setError('Venda de vale-presente exige CPF/CNPJ do cliente')

		if(this.venda.tipoDeTransacao !== 'Devolução' && this.venda.tipoDeTransacao !== 'Outros' && (this.venda.desconto && this.venda.desconto.valor > 0 
				|| this.venda.itens.filter(item => item.desconto && item.desconto.valor > 0).length > 0) 
				&& (!(this.venda.isVendaReaberta && (this.venda.isConsignado || this.venda.isDemonstracao)) || (this.venda.itens.filter(item => item.isCompra).length > 0))) {

			let valorBruto = 0
			let valorTotalDesconto = 0
			const valorDescontoCapa = obterDescontoDaVenda({
				...this.venda,
				desconto: this.venda.desconto,
			})
			if(this.venda.isDemonstracao || this.venda.isConsignado) {
				const itensDaVenda = this.venda.itens.filter(item => item.isCompra)
				itensDaVenda.forEach(item => {
					const valorLiquidoItem = this.validarTotalDoItem(item)
					const valorBrutoItem = this.obterSubTotalDoItem(item)

					if (item.possuiDescontoPorTabela) {
						valorBruto = valorBruto + valorLiquidoItem
					} else {
						valorBruto = valorBruto + valorBrutoItem
						valorTotalDesconto = Math.round((valorTotalDesconto + (valorBrutoItem - valorLiquidoItem)) * 100) / 100
					}
				})
			} else {
				this.venda.itens.forEach(item => {
					const valorLiquidoItem = this.validarTotalDoItem(item)
					const valorBrutoItem = this.obterSubTotalDoItem(item)

					if (item.possuiDescontoPorTabela) {
						valorBruto = valorBruto + valorLiquidoItem
					} else {
						valorBruto = valorBruto + valorBrutoItem
						valorTotalDesconto = Math.round((valorTotalDesconto + (valorBrutoItem - valorLiquidoItem)) * 100) / 100
					}
				})
			}

			valorTotalDesconto = valorTotalDesconto + valorDescontoCapa

			valorBruto = Math.round(valorBruto* 100) / 100
			valorTotalDesconto = Math.round(valorTotalDesconto* 100) / 100
		}

		const indice = this.formsDeCamposDaVenda.findIndex(form => !form.validate())
		if (indice !== -1) {
			this.painel = indice
			setTimeout(() => {
				this.panelHeaders[indice].$el.scrollIntoView()
			}, 300)
			return
		}

		if (
			this.venda.cpfDoCliente &&
			!isValidCPF(this.venda.cpfDoCliente) &&
			!validarCnpjAlfanumerico(this.venda.cpfDoCliente)
		) {
			throw new Error('Informe um CPF / CNPJ válido')
		}

		if (this.venda.tipoDeTransacao === 'Venda' && this.totalDaVenda <= 0 && !this.vendaEDemonstracaoOuConsignado) {
			throw new Error(
				'Valor do desconto não pode ser maior que o valor do item',
			)
		}

		if (
			(this.obrigatorioInformarCliente) &&
			!this.venda.cpfDoCliente?.length
		) {
			throw new Error('Informe um CPF ou CNPJ')
		}
		if (
			(this.venda.tipoDeTransacao === 'Devolução' || this.venda.tipoDeTransacao === 'Outros' ||
				this.venda.pedido) &&
			!this.venda.cliente?.id
		) {
			throw new Error('Cliente não cadastrado no sistema')
		}

		if (this.venda.pedido && !this.venda.cliente?.telefones.length) {
			throw new Error('Cadastre um telefone para o cliente informado')
		}

		if (
			(this.turnoDeVenda?.pontoDeVenda.loja.configuracaoDaLoja
				?.podeGerarEstoqueNaVenda &&
				!this.turnoDeVenda?.pontoDeVenda.criaPedidoNaVenda) ||
			this.venda.tipoDeTransacao === 'Devolução' ||
			this.venda.tipoDeTransacao === 'Outros'
		) {
			this.$emit('pagar', this.venda)
			return
		}

		if (!this.formVenda.validate()) {
			throw new Error('Verique os dados cadastrados')
		}

		const itens = this.venda.itens
		try {
			await AplicarTabelaDePrecoUseCase({
				loja: this.loja,
				itens,
				tipoDeCliente,
				validarLimiteDeProduto: false,
				vendaAtual: this.venda,
				tabelaDePreco: this.tabelaDePrecoSelecionada || undefined,
			})

			if (!this.vendaComErro) {
				const identificador = await this.vendaService.validarIdentificadorDeVenda(this.turnoDeVenda?.pontoDeVenda.id || '', this.venda.identificador || '')

				if (this.venda.identificador != identificador ) {
					this.venda.id = uuidv4()
					this.venda.identificador = identificador
				}
			}

			const itensUnificados = unificarItensDaVendaPorProduto(this.venda.itens)
			await Promise.all(itensUnificados)

			this.$emit('pagar', this.venda)
		} catch(error) {
			AlertModule.setError(error)
			return
		}
	}

	get cadastroDoClienteIncompleto() {
		return () =>
			!this.venda ||
			!!this.venda.cliente ||
			'Favor completar o cadastro do cliente'
	}

	get existeItemValePresente() {
		return this.venda?.itens.some(item => item.produto.isValePresente) ?? false
	}

	get venda() {
		return VendaModule.vendaAtual as Venda
	}

	set venda(venda: Venda) {
		VendaModule.setVendaAtual(venda)
	}

	get turnoDeVenda() {
		return VendaModule.turnoDeVenda
	}

	get temVendaComPagamentos() {
		return VendaModule.temVendaComPagamentos
	}

	get total() {
		return obterTotalDaVenda(this.venda)
	}

	get subtotal() {
		return obterTotalDosItensDaVenda(this.venda)
	}

	get loja() {
		return VendaModule.lojaDaVenda
	}

	get recarregaVenda() {
		return VendaModule.recarregaVenda
	}

	set recarregaVenda(recarregaVenda: boolean) {
		VendaModule.setRecarregaVenda(recarregaVenda)
	}

	get totalDaVenda() {
		return this.validarTotalDaVenda(this.venda)
	}

	get devolucaoParcial() {
		return !this.loja?.configuracaoDaLoja.devolucaoParcial && this.venda.itens.find(item => item.quantidade < 0)
	}

	get ehUmaDevolucaoOuTroca() {
		const tipoDeTransacao = this.venda?.tipoDeTransacao
		return tipoDeTransacao === 'Devolução' || tipoDeTransacao === 'Outros'
	}

	get ehUmaTroca() {
		return this.ehUmaDevolucaoOuTroca && Number(contarItensParaCompra(this.venda)) > 0
	}

	get corDoBotaoDePagamento() {
		if (!this.ehUmaDevolucaoOuTroca) return 'success'
		return this.ehUmaTroca ? 'primary' : 'error'
	}

	get corDaFaixaDeContadores() {
		return `${this.corDoBotaoDePagamento} darken-2`
	}

	get estiloDoBotaoDePagamento() {
		return {
			zIndex: this.zIndexPagamentoEmAndamento,
			borderTopLeftRadius: this.ehUmaDevolucaoOuTroca ? '0px' : undefined,
			borderTopRightRadius: this.ehUmaDevolucaoOuTroca ? '0px' : undefined,
		}
	}

	get displayTotalDoBotaoDePagamento() {
		if (!this.venda) return 'R$ 0,00'
		const total = this.validarTotalDaVenda(this.venda)
		return total < 0
			? `-R$ ${formatarMoeda(Math.abs(total))}`
			: `R$ ${formatarMoeda(total)}`
	}

	created() {
		document.addEventListener('keydown', this.atalhoDeUltimaVenda)
		document.addEventListener('keydown', this.atalhoDeNovaVenda)
		document.addEventListener('keydown', this.atalhoDeClienteOuCpf)
		this.$emit('update:pedindoCliente', VendaModule.lembraDePedirOCliente)
	}

	mounted() {
		this.focarNaTela()
	}

	async focarNaTela() {
		await nextTick()
		if (!this.pedindoCliente) {
			this.focarCampoDaBuscaDeProduto()
		} else {
			this.campoDeClienteDoDialogo.focus()
		}
	}

	pedirCliente() {
		this.$emit('update:pedindoCliente', true)
		this.focarNaTela()
	}

	destroyed() {
		document.removeEventListener('keydown', this.atalhoDeUltimaVenda)
		document.removeEventListener('keydown', this.atalhoDeNovaVenda)
		document.removeEventListener('keydown', this.atalhoDeClienteOuCpf)
		Object.values(this.menuTimers).forEach(timer => clearTimeout(timer))
	}

	atalhoDeClienteOuCpf(event: KeyboardEvent) {
		if (event.altKey && event.key.toLowerCase() === 'c') {
			event.preventDefault()
			this.campoDeCliente.focus()
		}
	}

	validarTotalDoItem(item: ItemDaVenda) {
		let totalDoItem = obterTotalDoItem(item)
		if (this.venda.tipoDeTransacao === 'Devolução' || this.venda.tipoDeTransacao === 'Outros') {
			return totalDoItem
		} else if (totalDoItem < 0) {
			return (totalDoItem = 0)
		}
		return totalDoItem
	}

	validarTotalDaVenda(venda: Venda) {
		let totalDaVenda = obterTotalDaVenda(venda)
		if (this.venda.tipoDeTransacao === 'Devolução' || this.venda.tipoDeTransacao === 'Outros') {
			return totalDaVenda
		} else if (totalDaVenda < 0) {
			return (totalDaVenda = 0)
		}
		return totalDaVenda
	}

	validarSubTotalDaVenda(venda: Venda) {
		let subTotalDaVenda = obterTotalDosItensDaVenda(venda)
		if (this.venda.tipoDeTransacao === 'Devolução' || this.venda.tipoDeTransacao === 'Outros') {
			return subTotalDaVenda
		} else if (subTotalDaVenda < 0) {
			return (subTotalDaVenda = 0)
		}
		return subTotalDaVenda
	}

	colorItem(item: any) {
		if (item.selecionadoViaVitrineVirtual) return ['purple lighten-4']
		if(this.venda.isConsignado) return ['yellow lighten-4']
		if(item.isBrinde) return ['green lighten-4']			
		if(item.idConjunto !== null && item.idConjunto !== '' && !item.isCompra) return ['primary lighten-4']
		if(this.venda.isVendaReaberta && this.venda.isDemonstracao && item.isCompra)  return ['light green accent-5']
		if(this.venda.isDemonstracao) return ['grey']
		return ['white']
	}

	podeVenderItem(item) {
		return (
			(this.venda.isVendaReaberta &&
			(this.vendaEDemonstracaoOuConsignado) &&
			item.quantidade > 0 &&
			(item.idConjunto && item.idConjunto.length > 0 || !item.idConjunto)) 
			||
			(item.quantidade > 0 && 
			item.isDaVendaReaberta && 
			(!item.isDemonstracao || item.isConsignado))
		)
	}

	atalhoDeUltimaVenda(event: KeyboardEvent) {
		if (this.panelHeaders && !this.panelHeaders.length) return
		if (event.altKey && event.key.toLowerCase() === 'u') {
			event.preventDefault()
			this.panelHeaders[this.panelHeaders.length - 1].$el.click()
			setTimeout(() => {
				this.camposDeVenda[this.camposDeVenda.length - 1].focus()
			})
		}
	}

	atalhoDeNovaVenda(event: KeyboardEvent) {
		if (!this.podeCancelarVenda) return
		if (event.altKey && event.key.toLowerCase() === 'n') {
			event.preventDefault()
			this.botaoDeCancelamentoDeVenda.$el.click()
		}
	}

	async validarPagamentos() {

		const resultado = await VendaModule.autenticarAcao({ regra: 'pode-excluir-item-de-venda' })
		if (resultado?.autenticado) {
			try {
				const pagamentosPorTef = VendaModule.vendaAtual?.pagamentos.filter(
					pagamento =>
						pagamento.tipoDePagamento.formaDePagamento === 'TEF Crédito' ||
						pagamento.tipoDePagamento.formaDePagamento === 'TEF Débito' ||
						pagamento.tipoDePagamento.formaDePagamento === 'TEF Pix'
				)

				if (pagamentosPorTef && pagamentosPorTef?.length > 0)
					throw new Error(
						'Existe pagamento(s) por tef autorizado(s) na venda atual, não é possível iniciar uma nova venda.',
					)

				this.iniciarNovaVenda()
			} catch (error: any) {
				AlertModule.setError(error)
				return
			}
		} else {
			return
		}
	}

	async iniciarNovaVenda() {
		const identificador = await this.vendaService.gerarIdentificadorDeVenda(
			this.turnoDeVenda?.pontoDeVenda.id || '',
		)
		await VendaModule.iniciarNovaVenda({ identificador, novaVendaReaberta: false })
		this.$emit('cancelar')
		this.$emit(
			'update:pedindoCliente',
			this.loja?.configuracaoDaLoja.lembreteDeCpfCnpj || false,
		)
		
		const comandaJson = localStorage["COMANDA_IMPORTADA"]
		const comanda: Comanda | null = comandaJson ? JSON.parse(comandaJson) : null

		if(comanda) {
			const comandaSalvar: Comanda = {
				id: comanda.id,
				identificador: comanda.identificador,
				dataHoraDeAbertura: comanda.dataHoraDeAbertura,
				aberto: true,
				nome: comanda.nome,
				descricao: '',
				itemDaComanda: comanda.itemDaComanda,
				createdAt: comanda.createdAt,
				updatedAt: comanda.updatedAt,
				taxaDeServico: 0,
				aguardandoProcessamentoNoCaixa: false,
			}

			await this.comandaUseCase.save(comandaSalvar)
		}
		
		this.cpfOuCnpjDoCliente = null
		this.cpfOuCnpjDoClienteDoDialogo = null
		if (this.venda.pontoDeVenda?.exigeVendedor && (!this.venda.vendedor || this.venda.vendedor.length === 0)) {
			this.dialogoDeVendedor.mostrar()
		}
		this.vendaComErro = false
		this.focarNaTela()

		if (this.pdvSomenteDemonstracaoEConsignado && this.venda) {
			this.venda.isDemonstracao = true
		}

		await this.alternaModalidadeDeVenda()
		if (this.turnoDeVenda) await this.findProdutoUseCase.updateStatusRfid(this.turnoDeVenda.pontoDeVenda.id)
	}

	focarCampoDaBuscaDeProduto() {
		if (
			this.venda.cpfDoCliente &&
			(isValidCPF(this.venda.cpfDoCliente) ||
				validarCnpjAlfanumerico(this.venda.cpfDoCliente))
		) {
			this.$emit('focarCampoDeBusca')
		}
	}

	get podeExcluirItemDeVenda() {
		return UserLoginStore.permiteRegraDeNegocio('pode-excluir-item-de-venda')
	}

	get podeCancelarVenda() {
		return UserLoginStore.permiteRegraDeNegocio('pode-cancelar-venda')
	}

	get podeConcederDesconto() {
		return UserLoginStore.permiteRegraDeNegocio('pode-conceder-desconto')
	}

	get exigeInformarVendedor() {
		return VendaModule.turnoDeVenda &&
			VendaModule.turnoDeVenda.pontoDeVenda.obrigaInformarVendedor
	}

	async removerItemDaVenda(indice: number) {
		if (indice <= -1) return

		if (this.venda.itens[indice].idConjunto !== undefined && this.venda.itens[indice].idConjunto !== null) {
			const itemDeletado = this.venda.itens[indice]

			while (
				this.venda.itens.some(
					item => item.idConjunto === itemDeletado.idConjunto,
				)
			) {
				const itemIndice = this.venda.itens.findIndex(
					produto => produto.idConjunto === itemDeletado.idConjunto,
				)
				this.venda.itens.splice(itemIndice, 1)
			}
		} else {
			this.venda.itens.splice(indice, 1)
		}

		VendaModule.setVendaAtual(this.venda)

		if (
			this.venda.itens.length == 0 &&
			(this.venda.tipoDeTransacao == 'Devolução' ||
			this.venda.tipoDeTransacao == 'Outros')
		) {
			this.iniciarNovaVenda()
		}
	}

	async projetaEstoqueDosItensDaVenda(itens: ItemDaVenda[]): Promise<boolean> {
		const projecoesPorItemDaVenda = await Promise.all(
			itens.map(async itemDaVenda => {
				let podePagarOsItens = true
				await this.findEstoqueUseCase
					.getEstoqueDoItemDaVendaNaLoja(
						itemDaVenda.produto.id,
						itemDaVenda.quantidade.toString(),
						this.turnoDeVenda?.pontoDeVenda.loja.id || '',
						itemDaVenda.autenticadoParaLiberarProdutoSemEstoque,
					)
					.catch(error => {
						podePagarOsItens = false
						AlertModule.setError(error.response.data[0])
					})
				return podePagarOsItens
			}),
		)
		return projecoesPorItemDaVenda.some(
			estoqueNegativo => estoqueNegativo === false,
		)
	}

	@Watch('venda', { immediate: true })
	onChangeVenda(vendaAtual: Venda, vendaAnterior: Venda | null) {
		if (
			!vendaAnterior ||
			vendaAtual.itens.length > vendaAnterior.itens.length
		) {
			setTimeout(() => {
				this.panelHeaders &&
					this.panelHeaders[this.panelHeaders.length - 1].$el.scrollIntoView()
			})
		}
	}

	confirmarCliente() {
		if (!this.formDoDialogoDeCliente.validate()) return
		this.$emit('update:pedindoCliente', false)
		this.cpfOuCnpjDoCliente = this.cpfOuCnpjDoClienteDoDialogo
		this.focarNaTela()
	}

	async confirmarSemCliente() {
		this.$emit('update:pedindoCliente', false)
		this.venda.cpfDoCliente = null
		this.venda.cliente = null
		this.cpfOuCnpjDoClienteDoDialogo = null
		this.cpfOuCnpjDoCliente = null
		this.focarNaTela()
	}

	@Watch('recarregaVenda')
	onRecarregarVenda(recarregarVenda: boolean) {
		if (!this.venda) return
		if (!recarregarVenda) return
		this.cpfOuCnpjDoCliente = formatarCnpjOuCpf(
			this.venda.cliente?.cnpjOuCpf || this.venda.cpfDoCliente || '',
		)
		this.recarregaVenda = false
	}

	@Watch('buscandoCliente', { immediate: true })
	onChangeBuscandoCliente(valor: boolean) {
		this.$emit('buscandoCliente', valor)
	}

	@Watch('venda.itens', { immediate: true })
	onChangeItensDaVenda(itensAnterior: ItemDaVenda[], itensAtuais: ItemDaVenda[]) {
		if (this.venda.isVendaReaberta && (this.venda.isConsignado || this.venda.isDemonstracao)) {
			if (itensAnterior.filter(item => item.isCompra).length > 0 && itensAtuais.filter(item => item.isCompra).length === 0) {
				this.venda.desconto = null
				this.venda.descontoBase = null
			}
		}
	}

	async enviarItemDeVendaValidado(produtoSku: string[] | null) {
		if (!produtoSku) return
		try {
			await this.validarEstoque(produtoSku)
		} catch (error: any) {
			AlertModule.setWarning(error)
		}
	}

	validarEstoque(produtosSkus: string[] | null) {
		if (!produtosSkus) return

		const quantidadesDosItens: number[] = []

		produtosSkus.forEach(sku => {
			const quantidade = (VendaModule.vendaAtual?.itens
			.find(item => item.produto.sku === sku)?.quantidade || 0)

			quantidadesDosItens.push(quantidade)
		}) 

		const podeGerarEstoque = this.$route.fullPath === '/caixa' ?
			VendaModule.lojaDaVenda?.configuracaoDaLoja.podeGerarEstoqueNaVenda :
			VendaModule.lojaDaEntrada?.configuracaoDaLoja.podeGerarEstoqueNaVenda

		const eUmaDemonstracaoEReaberta = VendaModule.vendaAtual?.isVendaReaberta
			&& (VendaModule.vendaAtual.isDemonstracao || VendaModule.vendaAtual?.isConsignado)
			&& VendaModule.vendaAtual.itens.some(item => item.produto.sku && produtosSkus.includes(item.produto.sku))

		if (!podeGerarEstoque && !VendaModule.vendaAtual?.itens.some(item => item.produto.isValePresente)) {
			if (this.podeLiberarProdutoSemEstoque && !eUmaDemonstracaoEReaberta && !this.isTelaDeTroca && VendaModule.lojaDaVenda?.configuracaoDaLoja.exibeNotificacaoEstoqueNegativo && this.venda.tipoDeTransacao !== 'Devolução') {
				if (VendaModule.lojaDaVenda) {
					return this.findProdutoUseCase.validaEstoqueNegativando(produtosSkus || undefined, VendaModule.lojaDaVenda.id, quantidadesDosItens)
				}}}
	}

	async validaBloqueiosDePagamento(isTipo: boolean, tipoVenda: string){
		if(!this.venda) return
		if(!this.loja) return

		if(isTipo){
			const tiposDePagamentoBloqueadosDoCliente = await this.findClienteUseCase.listarTiposDePagamentoBloqueadosCliente(this.venda.cliente?.id, this.turnoDeVenda?.pontoDeVenda.loja.id)
			const nomesBloqueados = tiposDePagamentoBloqueadosDoCliente.map(tipo => tipo.nome).join(', ');
			const possuiBloqueioGeral = tiposDePagamentoBloqueadosDoCliente.some(tipo => tipo.nome === tipoVenda);

			if (possuiBloqueioGeral) {
				const liberado = await this.liberarVendaClienteInadimplente()
				if (!liberado) return AlertModule.setWarning(`${tipoVenda} não liberado para este cliente. Entrar em contato com sua supervisão.`)
				return
			}

			if (tipoVenda == 'Venda'){
				const tiposDePagamentoDaLoja = this.loja?.tiposDePagamento.map(pagamento => pagamento.nome);
				const todosBloqueados = tiposDePagamentoDaLoja.every(tipo =>
					tiposDePagamentoBloqueadosDoCliente.some(bloqueado => bloqueado.nome === tipo));

				if(todosBloqueados){
					const liberado = await this.liberarVendaClienteInadimplente()
					if (!liberado) return AlertModule.setWarning(`Pagamento(s): ${nomesBloqueados} não liberado(s) para este cliente. Entrar em contato com sua supervisão.`)
				}
			}
		}
	}

	async liberarVendaClienteInadimplente(): Promise<boolean> {
		if (!this.loja?.configuracaoDaLoja?.exigeAutenticacaoParaLiberarVendaClienteInadimplente) return false
		const autenticacao = await VendaModule.autenticarAcaoTelaDeCaixa({ regra: 'pode-liberar-venda-cliente-inadimplente' })
		return !!autenticacao?.autenticado
	}

	get podeLiberarProdutoSemEstoque() {
		return UserLoginStore.permiteRegraDeNegocio('pode-liberar-produto-sem-estoque')
	}

	async zerarSaldoDaTroca(){
		this.venda.desconto = {isPercentual: false, valor: Math.abs(this.valorDescontoASerAplicadoNaTroca)}
	}

	async confirmarZerarSaldoDaTroca(){
		const itensDaDevolucao = this.venda.itens.filter(item => item.quantidade < 0)
		const itensDaVenda = this.venda.itens.filter(item => item.quantidade > 0)
		let valorDevolucao = 0;
		let valorVenda = 0;

		itensDaDevolucao.forEach(itemDaDevolucao => {
			Number((valorDevolucao += itemDaDevolucao.preco  * Math.abs(itemDaDevolucao.quantidade)).toFixed(2));
		});

		itensDaVenda.forEach(itemDaVenda => {
			Number((valorVenda += itemDaVenda.preco * itemDaVenda.quantidade).toFixed(2));
		});

		this.valorDescontoASerAplicadoNaTroca = Number((valorVenda - valorDevolucao).toFixed(3))
		if(this.loja?.configuracaoDaLoja.permiteZerarSaldoVoucher != undefined 
			&& -(this.valorDescontoASerAplicadoNaTroca) <= this.loja?.configuracaoDaLoja.permiteZerarSaldoVoucher
			&& -(this.valorDescontoASerAplicadoNaTroca) > 0
			&& itensDaVenda.length > 0)
		{
			const confirmacao = this.$refs.confirmaZerarSaldo as Confirmacao;
			await confirmacao.mostrar();
		}
	}

	async validaVenda() {
		try {

			if (this.loja?.configuracaoDaLoja.permiteZerarSaldoVoucher != undefined
				&& this.loja?.configuracaoDaLoja.permiteZerarSaldoVoucher > 0 
				&& this.venda.pagamentos.length < 1
				&& (this.venda.tipoDeTransacao == 'Devolução' 
				|| this.venda.tipoDeTransacao == 'Outros')) {
				await this.confirmarZerarSaldoDaTroca()
			}

			await this.validarSeVendaExigeCpf()

			if(this.venda.isDemonstracao && this.venda.cpfDoCliente){
				const listaDeIds: string[] = []
				VendaModule.vendaAtual?.itens.forEach(item => {
					const produtoId = item.produto.id

					if (!produtoId) return
					if (item.isCompra) return
					if (item.isDaVendaReaberta || item.quantidade === 0) return

					listaDeIds.push(produtoId)
				})
				
				this.validarItensDemonstracao(listaDeIds) 
			}
			const listaDeSkus: string[] = []

			VendaModule.vendaAtual?.itens.forEach(item => {
				if (item.produto.sku) {
					listaDeSkus.push(item.produto.sku);
				}
			})

			this.enviarItemDeVendaValidado(listaDeSkus)
		} catch (error) {
			AlertModule.setError(error)
		}
	}

	async validaSeHaTiposDePagamentoDisponiveisParaCpf(){
		if(!this.venda) return
		if(!this.cpfOuCnpjDoCliente) return
		if(!this.venda.cliente) return

		if (this.venda.isDemonstracao){ 
			this.validaBloqueiosDePagamento(true, 'Demonstração')
		}
		else if (this.venda.isBrinde){
			this.validaBloqueiosDePagamento(true, 'Brinde')
		}
		else if (this.venda.isConsignado){
			this.validaBloqueiosDePagamento(true, 'Consignado')
		}
		else if (this.venda.isTroca){
			this.validaBloqueiosDePagamento(true, 'Troca')
		}
		else{
			this.validaBloqueiosDePagamento(true, 'Venda')
		}
	}

	async alternaModalidadeDeVenda() {
		
		if(!this.loja || !this.venda) return

		let params;
		if(this.venda.isConsignado || this.venda.isDemonstracao) {
			params = {
				isDevolucao:false,
				isDemonstracao:true,
				isVenda:false,
			}
		}else if (this.venda.temDevolucao) {
			params = {
				isDevolucao:true,
				isDemonstracao:false,
				isVenda:false,
			}
		} else{
			params = {
				isDevolucao:false,
				isDemonstracao:false,
				isVenda:true,
			}
		}

		const modalidade = await this.findModalidadeDeVendaUseCase.findModalidadePadrao(this.loja.id, params)

		this.venda.modalidadeDeVenda = modalidade
	}

	get retornoDeDemonstracao(){
		return this.venda.isVendaReaberta && (this.venda.isDemonstracao || this.venda.isConsignado)
	}

	alteraCpfOuCnpj(){
		if(this.venda.cliente && this.cpfOuCnpjDoCliente !== this.venda.cliente?.cnpjOuCpf && this.retornoDeDemonstracao){
			this.cpfOuCnpjDoCliente = formatarCnpjOuCpf(this.venda.cliente.cnpjOuCpf)
		}
	}

	get disabledBtnDeDesconto(){
		return this.temVendaComPagamentos || 
		(this.venda.tipoDeTransacao === 'Devolução' && this.venda.itens.filter(item => item.quantidade >= 1).length < 1) || 
		this.venda.tipoDeTransacao === 'Outros' || 
		this.venda.valorDeCashbackAplicado !== 0 || 
		this.existeItemValePresente ||
		this.venda.itens.reduce((soma, item) => soma + (item.preco * item.quantidade), 0) === 0
	}

	async validarItensDemonstracao(produtosIds: string[] | null) {
		if (!produtosIds || produtosIds.length === 0) return
		if (!this.venda.cpfDoCliente) return
		if (!this.venda.pontoDeVenda) return

		try {
			const params = { produtosIds: produtosIds }
			await this.vendaService.validarItensDemonstracaoCliente(params, this.venda.cpfDoCliente, this.venda.pontoDeVenda.loja.grupoEconomico.id)
		} catch (error: any) {
			AlertModule.setWarning(error)
		}
	}

	get pdvSomenteDemonstracaoEConsignado() {
		return this.turnoDeVenda?.pontoDeVenda?.somenteDemonstracaoEConsignado || false
	}

	get modoNoturno(){
		return AppStore.modoNoturno
	}

	abrirMenu(indice: number) {
		if (this.menuTimers[indice]) {
			clearTimeout(this.menuTimers[indice])
			delete this.menuTimers[indice]
		}
		
		if (!this.menuAtivo.includes(indice)) {
			this.menuAtivo.push(indice)
		}
	}

	fecharMenu(indice: number) {
		if (!this.menuFixado[indice]) {
			this.menuAtivo = this.menuAtivo.filter(menu => menu !== indice)
		}
	}

	fecharMenuComDelay(indice: number) {
		if (this.menuFixado[indice]) return
		
		this.menuTimers[indice] = setTimeout(() => {
			if (!this.menuFixado[indice]) {
				this.menuAtivo = this.menuAtivo.filter(menu => menu !== indice)
			}
			delete this.menuTimers[indice]
		}, 200) as any
	}

	fixarMenu(indice: number) {
		this.$set(this.menuFixado, indice, true)
		if (!this.menuAtivo.includes(indice)) {
			this.menuAtivo.push(indice)
		}
		
		if (this.menuTimers[indice]) {
			clearTimeout(this.menuTimers[indice])
			delete this.menuTimers[indice]
		}
	}

	desFixarMenu(indice: number) {
		this.$set(this.menuFixado, indice, false)
		
		this.menuTimers[indice] = setTimeout(() => {
			this.menuAtivo = this.menuAtivo.filter(menu => menu !== indice)
			delete this.menuTimers[indice]
		}, 300) as any
	}

	get possuiItemSelecionadoViaVitrineVirtual() {
		return this.venda?.itens?.some(item => item.selecionadoViaVitrineVirtual) ?? false
	}

	get utilizaOfertaRelacionada() {
		return VendaModule.lojaDaVenda?.configuracaoDaLoja.utilizaOfertaRelacionadaNoCaixa
	}

	registrarOfertas(produtoId: string, ofertas: OfertaRelacionadaDoProduto[]) {
		this.$set(this.ofertasRelacionadasPorItem, produtoId, ofertas)
	}

	async abrirOfertasRelacionadas(produto: FormProdutoSimplesFilho) {
		const produtoId = produto.id
		const skuSelecionado = produto.skuPai !== null ? produto.skuPai : produto.sku
		const nomeItem = produto.nome
		const ofertas = this.ofertasRelacionadasPorItem[produtoId] || []
		
		if (!ofertas.length) {
			this.dialogoDeOfertas.mostrar(produto.nome, ofertas, skuSelecionado)
			return
		}
		let ofertasEnriquecidas: OfertaRelacionadaDoProduto[] = [...ofertas]
		this.$set(this.carregandoOfertasPorItem, produtoId, true)
		try {
			const resultados = await Promise.allSettled(
				ofertas.map(o => this.findProdutoUseCase.findProdutoPorIdentificador(o.produtoComplementoSkuPai)),
			)
			const produtos = resultados.map(r => r.status === 'fulfilled' ? r.value : null)

			ofertasEnriquecidas = ofertas.map((oferta, idx) => {
				const produto = produtos[idx]
				return {
					...oferta,
					nome: produto?.nome,
					urlImagem: produto?.urlImagens?.find(i => i.padrao)?.imagemUrl
						?? produto?.urlImagens?.[0]?.imagemUrl
						?? null,
				}
			})

			const itensMapeados: Array<{ ofertaIdx: number; item: ItemDaVenda }> = []
			const variantesPendentes: Array<{ ofertaIdx: number; produto: ProdutoComVariantes }> = []

			produtos.forEach((produto, ofertaIdx) => {
				if (!produto) return
				if (produto.tipo === 'Com Variantes') {
					variantesPendentes.push({ ofertaIdx, produto: produto as ProdutoComVariantes })
					return
				}
				itensMapeados.push({
					ofertaIdx,
					item: {
						id: '',
						produto: converterProdutoParaProdutoSimples(produto),
						quantidade: 1,
						quantidadeLida: 0,
						desconto: { isPercentual: true, valor: 0.0 },
						preco: produto.preco || 0,
						precoDeCusto: 0,
						idConjunto: null,
						descontoVarejo: 0,
						percentualCashback: 0,
						diasParaEfetivarCashback: 0,
						isBrinde: false,
						idItemNotaOrigem: null,
						chaveNotaOrigem: null,
						diasParaExpirarCashback: 0,
						possuiDescontoPorTabela: false,
						valorDescontoRateadoDoItem: 0,
						itemDeDevolucao: false,
						isTotalmenteTrocado: false,
						motivoCancelamento: null,
						isCompra: false,
						idItemOrigem: '',
						isDaVendaReaberta: false,
						vendedor: null,
						autenticadoParaLiberarProdutoSemEstoque: false,
						vendaOrigemDoItem: null,
						valorFreteRateado: 0,
						isItemReferenteATroca: false,
						isDeOutraLoja: false,
						percentualDescontoTabelaPreco: 0,
						precoDeCustoReal: 0,
						skuPai: produto.tipo === 'Variante' ? produto.skuPai : produto.sku,
					},
				})
			})

			if (variantesPendentes.length) {
				const variantesResultados = await Promise.allSettled(
					variantesPendentes.map(({ produto }) => this.findProdutoUseCase.buscarVariantes(produto.id)),
				)
				variantesResultados.forEach((resultado, i) => {
					const { ofertaIdx, produto } = variantesPendentes[i]
					const variante = resultado.status === 'fulfilled' && resultado.value.length > 0
						? resultado.value[0]
						: null
					if (!variante) {
						ofertasEnriquecidas[ofertaIdx] = { ...ofertasEnriquecidas[ofertaIdx], preco: produto.preco ?? 0 }
						return
					}
					itensMapeados.push({
						ofertaIdx,
						item: {
							id: '',
							produto: converterProdutoParaProdutoSimples(variante),
							quantidade: 1,
							quantidadeLida: 0,
							desconto: { isPercentual: true, valor: 0.0 },
							preco: variante.preco || 0,
							precoDeCusto: 0,
							idConjunto: null,
							descontoVarejo: 0,
							percentualCashback: 0,
							diasParaEfetivarCashback: 0,
							isBrinde: false,
							idItemNotaOrigem: null,
							chaveNotaOrigem: null,
							diasParaExpirarCashback: 0,
							possuiDescontoPorTabela: false,
							valorDescontoRateadoDoItem: 0,
							itemDeDevolucao: false,
							isTotalmenteTrocado: false,
							motivoCancelamento: null,
							isCompra: false,
							idItemOrigem: '',
							isDaVendaReaberta: false,
							vendedor: null,
							autenticadoParaLiberarProdutoSemEstoque: false,
							vendaOrigemDoItem: null,
							valorFreteRateado: 0,
							isItemReferenteATroca: false,
							isDeOutraLoja: false,
							percentualDescontoTabelaPreco: 0,
							precoDeCustoReal: 0,
							skuPai: variante.skuPai,
						},
					})
				})
			}

			if (this.loja && itensMapeados.length) {
				const tipoDeCliente = this.venda && this.venda.tipoDeCliente ? this.venda.tipoDeCliente : null
				const itensComPreco = await AplicarTabelaDePrecoUseCase({
					loja: this.loja,
					itens: itensMapeados.map(m => m.item),
					tipoDeCliente,
					validarLimiteDeProduto: false,
					vendaAtual: this.venda,
					tabelaDePreco: this.tabelaDePrecoSelecionada || undefined,
				})
				itensMapeados.forEach(({ ofertaIdx }, i) => {
					ofertasEnriquecidas[ofertaIdx] = {
						...ofertasEnriquecidas[ofertaIdx],
						preco: itensComPreco[i]?.preco ?? 0,
					}
				})
			}
			this.dialogoDeOfertas.mostrar(nomeItem, ofertasEnriquecidas, skuSelecionado)
		} catch {
			this.dialogoDeOfertas.mostrar(nomeItem, ofertasEnriquecidas, skuSelecionado)
		} finally {
			this.$set(this.carregandoOfertasPorItem, produtoId, false)
		}
	}

	async adicionarOferta(oferta: OfertaRelacionadaDoProduto) {
		try {
			const produto = await this.findProdutoUseCase.findProdutoPorIdentificador(oferta.produtoComplementoSkuPai)

			if (produto.tipo === 'Com Variantes') {
				this.dialogoDeSelecaoDeVarianteDeOferta.abrir(Promise.resolve(produto as ProdutoComVariantes))
				this.dialogoDeOfertas.fechar()
				return
			}

			const item: ItemDaVenda = {
				id: '',
				produto: converterProdutoParaProdutoSimples(produto),
				quantidade: 1,
				quantidadeLida: 0,
				desconto: { isPercentual: true, valor: 0.0 },
				preco: produto.preco || 0,
				precoDeCusto: 0,
				idConjunto: null,
				descontoVarejo: 0,
				percentualCashback: 0,
				diasParaEfetivarCashback: 0,
				isBrinde: false,
				idItemNotaOrigem: null,
				chaveNotaOrigem: null,
				diasParaExpirarCashback: 0,
				possuiDescontoPorTabela: false,
				valorDescontoRateadoDoItem: 0,
				itemDeDevolucao: false,
				isTotalmenteTrocado: false,
				motivoCancelamento: null,
				isCompra: false,
				idItemOrigem: '',
				isDaVendaReaberta: false,
				vendedor: null,
				autenticadoParaLiberarProdutoSemEstoque: false,
				vendaOrigemDoItem: null,
				valorFreteRateado: 0,
				isItemReferenteATroca: false,
				isDeOutraLoja: false,
				percentualDescontoTabelaPreco: 0,
				precoDeCustoReal: 0,
				skuPai: produto.tipo === 'Variante' ? produto.skuPai : produto.sku,
				selecionadoViaOfertaRelacionada: true,
			}
			this.$emit('incluirItem', item)
			this.dialogoDeOfertas.marcarAdicionado(oferta.produtoComplementoSkuPai)
		} catch (error) {
			AlertModule.setError(error)
		} finally {
			this.dialogoDeOfertas.finalizarCarregamento()
		}
	}

	async aoSelecionarVarianteDeOferta(produto: Produto | null) {
		if (!produto) return
		let item: ItemDaVenda | null = null
		const sku = produto.sku || ''
		try {
			item = {
				id: '',
				produto: converterProdutoParaProdutoSimples(produto),
				quantidade: 1,
				quantidadeLida: 0,
				desconto: { isPercentual: true, valor: 0.0 },
				preco: produto.preco || 0,
				precoDeCusto: 0,
				idConjunto: null,
				descontoVarejo: 0,
				percentualCashback: 0,
				diasParaEfetivarCashback: 0,
				isBrinde: false,
				idItemNotaOrigem: null,
				chaveNotaOrigem: null,
				diasParaExpirarCashback: 0,
				possuiDescontoPorTabela: false,
				valorDescontoRateadoDoItem: 0,
				itemDeDevolucao: false,
				isTotalmenteTrocado: false,
				motivoCancelamento: null,
				isCompra: false,
				idItemOrigem: '',
				isDaVendaReaberta: false,
				vendedor: null,
				autenticadoParaLiberarProdutoSemEstoque: false,
				vendaOrigemDoItem: null,
				valorFreteRateado: 0,
				isItemReferenteATroca: false,
				isDeOutraLoja: false,
				percentualDescontoTabelaPreco: 0,
				precoDeCustoReal: 0,
				skuPai: produto.tipo === 'Variante' ? produto.skuPai : produto.sku,
				selecionadoViaOfertaRelacionada: true,
			}

			const podeGerarEstoque = VendaModule.lojaDaVenda?.configuracaoDaLoja.podeGerarEstoqueNaVenda
			const eUmaDemonstracaoEReaberta = VendaModule.vendaAtual?.isVendaReaberta
				&& (VendaModule.vendaAtual.isDemonstracao || VendaModule.vendaAtual?.isConsignado)
				&& VendaModule.vendaAtual.itens.some(i => i.produto.id === produto.id)

			if (!podeGerarEstoque && !this.podeLiberarProdutoSemEstoque && !eUmaDemonstracaoEReaberta && !this.isTelaDeTroca) {
				if (VendaModule.lojaDaVenda) {
					const quantidadeAtual = VendaModule.vendaAtual?.itens.find(i => i.produto.id === produto.id)?.quantidade || 0
					await this.findProdutoUseCase.validarProduto(sku, VendaModule.lojaDaVenda.id, quantidadeAtual + 1)
				}
			}

			if (this.podeLiberarProdutoSemEstoque) {
				item.autenticadoParaLiberarProdutoSemEstoque = true
			}

			this.$emit('incluirItem', item)
		} catch (error: any) {
			const mensagem = getRequestError(error)
			const erroDeEstoque = item && (
				mensagem === 'A quantidade do produto excede o estoque disponível' ||
				mensagem === `Produtos ${sku} sem quantidade disponível em estoque` ||
				mensagem === 'Produto não possui estoque parametrizado'
			)
			if (erroDeEstoque) {
				AlertModule.setError(error)
				const resultado = await VendaModule.autenticarAcaoTelaDeCaixa({ regra: 'pode-liberar-produto-sem-estoque' })
				if (resultado?.autenticado) {
					item!.autenticadoParaLiberarProdutoSemEstoque = true
					item!.usuarioIdLiberacaoVendaSemEstoque = resultado.usuarioId
					this.$emit('incluirItem', item)
				}
			} else {
				AlertModule.setError(error)
			}
		}
	}

	get somenteItensDeVitrine(){
		const itensNormais = this.venda.itens.filter(item => !item.selecionadoViaVitrineVirtual)
		const temItensNormais = itensNormais.length > 0

		const itensVitrine = this.venda.itens.filter(item => item.selecionadoViaVitrineVirtual)
		const temItensVitrine = itensVitrine.length > 0

		return !temItensNormais && temItensVitrine
	}

}
